export default __webpack_public_path__ + "static/media/DA.4dd781a7.svg";